
import { AxiosRequestConfig } from 'axios';
import { CommonAxiosServiceWp }  from './common-axios-service-wp';
import { CompanyIdRequest, CompanyModel, CompanyResponse, GlobalResponseObject } from '@schemax-whatsapp/shared-models';

export class CompanyService extends CommonAxiosServiceWp {
    private getURLwithMainEndPoint(childUrl: string) {
        return '/company/' + childUrl;
    }

    async createCompany( request: CompanyModel, config?: AxiosRequestConfig): Promise<CompanyResponse> {
        return await this.axiosPostCall(this.getURLwithMainEndPoint('createCompany'), request, config);
    }

    async editCompany( request: CompanyModel, config?: AxiosRequestConfig): Promise<CompanyResponse> {
        return await this.axiosPostCall(this.getURLwithMainEndPoint('editCompany'), request, config);
    }

    async getAllCompanies(config?: AxiosRequestConfig): Promise<CompanyResponse> {
        return await this.axiosPostCall(this.getURLwithMainEndPoint('getAllCompanies'), null, config);
    }

    async deleteCompany( companyReq: CompanyIdRequest, config?: AxiosRequestConfig): Promise<CompanyResponse> {
        return await this.axiosPostCall(this.getURLwithMainEndPoint('deleteCompany'), companyReq, config);
    }

}